import { FC, memo } from 'react'
import { useSelector } from 'react-redux'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import FilterContent from './content'
import FilterModalHeader from './header'
import FilterModalFooter from './footer'
import ActionSheet from '../../action-sheet'
import { getCurrentOpenedFilterModal, getIsFilterLoading } from '../../../../redux/filters'
import { FilterModalType } from '../../filter-sort-section/types'
import CancellationPolicyModal from '../cancellation-policy-modal'
import Spinner from '../../../common/spinner'
import { FilterContentWrapper, LoadingOverlay, SpinnerWrapper } from './styles'

type Props = {
    filterStaticData: FilterSectionTransport
    handleModalToggle: () => void
}

const FilterModal: FC<Props> = ({ filterStaticData, handleModalToggle }) => {
    const currentOpenedFilterModal = useSelector(getCurrentOpenedFilterModal)
    const isLoading = useSelector(getIsFilterLoading)
    const isOpen = currentOpenedFilterModal === FilterModalType.FILTERS

    return (
        <>
            <ActionSheet
                isOpen={isOpen}
                onRequestClose={handleModalToggle}
                header={
                    <FilterModalHeader handleFilterToggle={handleModalToggle} filterStaticData={filterStaticData} />
                }
                footer={<FilterModalFooter handleModalToggle={handleModalToggle} filterStaticData={filterStaticData} />}
            >
                <FilterContentWrapper>
                    <FilterContent filterStaticData={filterStaticData} />
                </FilterContentWrapper>
                {isLoading && (
                    <>
                        <LoadingOverlay />
                        <SpinnerWrapper>
                            <Spinner $size="2rem" />
                        </SpinnerWrapper>
                    </>
                )}
            </ActionSheet>

            <CancellationPolicyModal
                title={filterStaticData.specificFilters.cancellationPolicy.title}
                policyPoints={filterStaticData.specificFilters.cancellationPolicy.policyPoints}
            />
        </>
    )
}

export default memo(FilterModal)
